var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a8815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35a51d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef8a34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec7e21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48d36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec7e21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec322b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db261f"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.3396112 2.76111421s-.3071547.11654681-.635091-.00000007c-.2609629-.09274488-.5233734-.40649302-.7389789-.51548542-.1250036-.06319152.1069568-.36439729-.140439-.28311008-.2473959.0812872-.6515067-.29636351-.6515067-.29636351s-.41748596-.50888206.1974516-.50888206c.6149376 0 1.912063.44182479 1.912063.44182479s.04857-.22817503.1543434-.33333333c.1057733-.10515832.1842043-.20177362.3575149-.17554874.1733105.02622487.2691126.2703683.2691126.2703683l-.2691126.10272508v.20284598s1.7991134-.55176147 2.2243767-.50888208c.4252634.04287938.0829976.50946007-.1737351.80524553-.0993078.11441399-.423549.34751732-.6206752.16062131-.1971261-.186896-.1240023.20206717-.3283111.32763669-.3331922.20478214-.4582684.39245398-.5728236.44705636-.1145551.05460238-.3650948 0-.3650948 0l.0731956.18782552s.0205168.22574317-.0731956.31575521c-.0937125.09001203-.1588628.15349359-.3872768.1265346s-.3362022.03036001-.4121559-.22088914c-.0759538-.25124915.1803385-.54594494.1803385-.54594494zm.1881511-.26023065v.58779761l.2584171-.21609933z",
    fill: "url(#d)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.714286 4.571429h2.285714v6.857143h-2.285714z",
    fill: "url(#e)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.428571 4.571429h2.285714v6.857143h-2.285714z",
    fill: "url(#f)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.142857 4.571429h2.285714v6.857143h-2.285714z",
    fill: "url(#g)",
    mask: "url(#h)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZm);
export default __webpack_public_path__ + "static/media/ZM.ec8745dafbd283d1f0d5cbce33331565.svg";
export { ForwardRef as ReactComponent };